import { Component, View, OnInit } from 'angular2/core';
import { CORE_DIRECTIVES, DatePipe } from 'angular2/common';
import { Router, RouteParams } from 'angular2/router';

import { Header } from '../layout/header/header';
import { Sidebar } from '../layout/sidebar/sidebar';
import { Event } from './event.model';
import { EventService } from './event.service';
import { AlertService, AlertMessage, MessageType } from '../alert/alert.service';
import { StringDate } from '../date/stringdate';

let template = require('./event-detail.html');

@Component({
  selector: 'event-detail'
})
@View({
  pipes: [DatePipe],
  directives: [CORE_DIRECTIVES, Header, Sidebar],
  template: template,
})
export class EventDetail implements OnInit {

  title: string;
  startDate: StringDate;
  endDate: StringDate;
  event: Event;

  constructor(
    public router: Router,
    public routeParams: RouteParams,
    private eventService: EventService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.event = new Event();
    this.startDate = new StringDate();
    this.endDate = new StringDate();

    let id = this.routeParams.get('id');
    if (id) {
      this.title = 'Editar evento';
      this.loadEvent(id);
    } else {
      this.title = 'Crear evento';
    }
  }

  save($event, event: Event) {
    $event.preventDefault();
    event.startDate = this.startDate.toDate();
    event.endDate = this.endDate.toDate();
    this.eventService.save(event).subscribe(
      response => {
        let savedEvent = response.json();
        this.alert('Evento guardado con éxito', MessageType.Success);
        this.router.navigate(['EventDetail', { id: savedEvent.id }]);
      },
      error => {
        this.alert('Error al guardar el evento', MessageType.Danger);
      }
    );
  }

  cancel($event) {
    this.router.navigate(['EventList']);
  }

  loadEvent(id: string) {
    this.eventService.get(id).subscribe(
      event => {
        this.event = event;
        this.startDate = new StringDate().setDate(this.event.startDate);
        this.endDate = new StringDate().setDate(this.event.endDate);
      },
      error => {
        this.alert('Error al recuperar los datos del evento', MessageType.Danger);
      }
    );
  }

  alert(text: string, type: MessageType) {
    this.alertService.push({ text, type });
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/event/event-detail.ts
 **/